import { Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import routes from '../config/routes';

const AccountingInformationTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    navigate(newValue);
  };

  return (
    <Tabs
      value={location.pathname}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      sx={{ justifyContent: 'flex-start' }}
    >
      <Tab
        label={t('accounting-info-report.petty-cash-withdrawal.title')}
        value={routes.protectedRoutes.pettyCashWithDrawalReport.path}
      />
      <Tab
        label={t('accounting-info-report.cash-count.title')}
        value={routes.protectedRoutes.cashCountReport.path}
      />
      <Tab
        label={t('accounting-info-report.recovery.title')}
        value={routes.protectedRoutes.recoveryReport.path}
      />
      <Tab
        label={t('accounting-info-report.exchange-purchase.title')}
        value={routes.protectedRoutes.exchangePurchaseReport.path}
      />
      <Tab
        label={t('accounting-info-report.fixed-fund.title')}
        value={routes.protectedRoutes.fixedFundReport.path}
      />
      <Tab
        label={t('accounting-info-report.cash-discrepancy.title')}
        value={routes.protectedRoutes.cashDiscrepancyReport.path}
      />
      <Tab
        label={t('accounting-info-report.extra-cash.title')}
        value={routes.protectedRoutes.extraCashReport.path}
      />
    </Tabs>
  );
};

export default AccountingInformationTabs;
